const moduleRoutes = {
  path: '/faturamento-tiss',
  component: () => import('@/views/Home'),
  children: [
    {
      path: '',
      component: () => import('./views/Home'),
      children: [
        { path: 'dashboard', component: () => import('./views/Dashboard') },
        { path: 'faturas', component: () => import('./views/Invoice') },
        {
          path: 'lotes-a-enviar',
          component: () => import('./views/LotsToSend')
        },
        { path: 'lotes-enviados', component: () => import('./views/SentLots') },
        {
          path: 'lotes-finalizados',
          component: () => import('./views/FinishedLots')
        },
        {
          path: 'relatorio-de-guias',
          component: () => import('./views/GuidesReport')
        },
        {
          path: 'configuracoes',
          component: () => import('./views/TissSettings')
        }
      ]
    },
    {
      path: ':batchId/gerenciar-guias',
      name: 'tiss-manage-guides',
      component: () => import('./views/ManageGuides')
    },
    {
      path: 'batch/:batchId/lotes-enviados/:guideId',
      name: 'tiss-manage-guide-items',
      component: () => import('./views/ManageGuideItems')
    }
  ]
}

export default router => {
  router.addRoute(moduleRoutes)
}
